module.exports = __webpack_public_path__ + "fonts/qtzaintextboldpc-bold.2f887675.woff";